import { render, staticRenderFns } from "./briefIntroduction.vue?vue&type=template&id=148cdb4a&"
import script from "./briefIntroduction.vue?vue&type=script&lang=js&"
export * from "./briefIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./briefIntroduction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports